export const CREATE_CHATBOT = 'create-chatbot';
export const CREATE_CHATBOT_FLOW_TEST = 'create-chatbot-flowtest';
export const CREATE_CHATBOT_BACK_PREVIOUS_STEP = 'create-chatbot-back-previous-step';
export const CREATE_CHATBOT_CLOSE = 'create-chatbot-close';
export const APPLICATION_CREATION_TEMPLATE_SELECTED = 'application-creation-template-selected';
export const APPLICATION_CREATION_TEMPLATE_CONFIRMED = 'application-creation-template-confirmed';
export const APPLICATION_CREATION_REQUEST_QUOTE = 'application-creation-request-quote';
export const APPLICATION_CREATION_TEMPLATE_TESTED = 'application-creation-template-tested';
export const APPLICATION_CREATION_ROUTER_HELP_CLICKED = 'application-creation-router-help-clicked';
